<template>
  <div class="login-root">
    <div
      v-show="!showLoginSuccess"
      class="wrapper"
      :class="{ transitionBackground: !showBgImg }"
      @keydown.enter="enter()"
    >
    <div class="flex1200">
      <!-- 登录框 -->
      <div class="board login-box" v-show="boardShow === 1">
        <h1
          class="font_18_black row"
          style="margin-bottom: 36px; font-size: 30px"
        >
          <img
            class="logo"
            src="@/assets/icons/logo2@2x.png"
            alt
          />泛亚人力企业服务平台
        </h1>
        <div class="loginflex">
          <div class="login-left">
            <div>账号登录</div>
            <div class="step">
              <div>账号</div>
              <!-- <img class="icon" src="@/assets/icons/Username@2x.png" alt /> -->
              <input
                v-model="user_name"
                class="font_16_black"
                type="text"
                placeholder="请输入用户名"
              />
              <div class="error-tip font_12_orange">{{ errors.userName }}</div>
            </div>
            <div class="step">
              <div>密码</div>
              <!-- <img class="icon" src="@/assets/icons/Password@2x.png" alt /> -->
              <input
                v-model="password"
                class="font_16_black"
                type="password"
                placeholder="请输入密码"
              />
              <div class="error-tip font_12_orange">{{ errors.password }}</div>
            </div>
            <div class="step">
              <div>验证码</div>
              <!-- <img class="icon" src="@/assets/icons/VerificationCode@2x.png" alt /> -->
              <div class="inputcode">
                <input
                  v-model="code"
                  class="font_16_black"
                  type="text"
                  placeholder="请输入验证码"
                />
                <div class="get_code" @click="get_code()">
                  <p class="get_text" v-show="!hasGotCode">获取验证码</p>
                  <div class="code_pic" v-show="hasGotCode">
                    <img class="code-img" :src="src" alt="验证码" />
                  </div>
                </div>
              </div>
              <div class="error-tip font_12_orange">{{ errors.code }}</div>
            </div>
            <div class="tips font_12_orange" style="padding-left: 0">
              {{ tips }}
            </div>
            <div class="forget" @click="forget()">忘记密码？</div>
            <el-button
              type="primary"
              round
              @click="login()"
              :loading="loginLoading"
              :disabled="isLoginDebounce"
              >登录</el-button
            >
          </div>
          <div class="line"></div>
          <div class="login-right">
            <div>扫码登录</div>
            <div class="saoma" @click="handleQrcodeClick">
              <div v-if="wechat_qrcode_url" class="qrcode-container" :class="{ expired: isQrcodeExpired }">
                <img
                  class="wechat-qrcode-image"
                  :src="wechat_qrcode_url"
                  alt="wechat-qrcode"
                />
                <!-- 过期遮罩 -->
                <div v-if="isQrcodeExpired" class="qrcode-overlay">
                  <div class="refresh-icon">
                    <i class="el-icon-refresh"></i>
                  </div>
                  <p class="expired-text">二维码已过期，点击重试</p>
                </div>
              </div>
              <p v-else class="font_14_darkgray wechat-tip">二维码加载中...</p>
            </div>
            <div class="qrcode-tips">
              <span>使用<span class="highlight">微信</span>扫描二维码登录</span>
              <span v-if="qrcodeCountdown > 0" class="countdown">剩余 {{ qrcodeCountdown }} 秒</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 邮箱验证框 -->
      <div class="board verify-email-box" v-show="boardShow === 2">
        <span class="backBtn" @click="toBoard(1)">
          <i class="el-icon-back"></i>
        </span>
        <h1 class="font_18_black row">邮箱验证</h1>
        <div class="input-item row">
          <img
            class="icon"
            src="@/assets/icons/mailbox@2x.png"
            alt
          />
          <input
            class="font_16_black"
            type="text"
            :value="data.email"
            readonly
          />
        </div>
        <div class="input-item row code">
          <div class="input_code">
            <img
              class="icon"
              src="@/assets/icons/VerificationCode@2x.png"
              alt
            />
            <input
              v-model="email_code"
              class="font_16_black"
              type="text"
              placeholder="请输入验证码"
            />
          </div>
          <div class="get_code">
            <p
              class="font_16_orange"
              v-show="!waitting"
              @click="get_email_code()"
            >
              获取验证码
            </p>
            <p class="font_16_darkgray" v-show="waitting">
              验证码已发送({{ seconds }}s)
            </p>
          </div>
        </div>
        <div class="tips font_12_orange">{{ this.tips }}</div>
        <el-button type="primary" round @click="verify()">完成验证</el-button>
      </div>
      <!-- 找回密码框1 -->
      <div class="board forget-box" v-show="boardShow === 3">
        <span class="backBtn" @click="toBoard(1)">
          <i class="el-icon-back"></i>
        </span>
        <h1 class="font_18_black row">找回密码</h1>
        <div class="input-item row">
          <img class="icon" src="@/assets/icons/Username@2x.png" alt />
          <input
            v-model="user_name"
            class="font_16_black"
            type="text"
            placeholder="请输入用户名"
          />
        </div>
        <div class="error-tip font_12_orange">{{ errors.forgetUserName }}</div>
        <el-button
          type="primary"
          style="margin-top: 114px"
          round
          @click="retrieve_step1()"
          >下一步</el-button
        >
      </div>
      <!-- 找回密码框2 -->
      <div class="board forget-box" v-show="boardShow === 4">
        <span class="backBtn" @click="toBoard(3)">
          <i class="el-icon-back"></i>
        </span>
        <h1 class="font_18_black row">找回密码</h1>
        <div class="input-item row">
          <img class="icon" src="@/assets/icons/Username@2x.png" alt />
          <input
            :value="user_name"
            class="font_16_black"
            type="text"
            readonly
          />
        </div>
        <div class="input-item row">
          <img
            class="icon"
            src="@/assets/icons/mailbox@2x.png"
            alt
          />
          <input
            class="font_16_black"
            type="text"
            :value="user_email"
            readonly
          />
        </div>
        <!-- 邮箱验证码 -->
        <div class="email-code-row">
          <div class="input-item email-input-wrapper">
            <img class="icon" src="@/assets/icons/VerificationCode@2x.png" alt />
            <input
              v-model="email_code"
              class="font_16_black"
              type="text"
              placeholder="请输入邮箱验证码"
            />
          </div>
          <div class="email-code-btn" :class="{ disabled: waitting }">
            <span v-show="!waitting" @click="showTencentCaptcha()">获取邮箱验证码</span>
            <span v-show="waitting">验证码已发送({{ seconds }}s)</span>
          </div>
        </div>
        <div class="error-tip font_12_orange">{{ errors.emailCode }}</div>
        <div class="input-item row">
          <img class="icon" src="@/assets/icons/Password@2x.png" alt />
          <input
            v-model="password"
            class="font_16_black"
            type="password"
            placeholder="请输入密码"
          />
          <!-- <span class="required">*</span> -->
        </div>
        <div class="error-tip font_12_orange">{{ errors.forgetPassword }}</div>
        <div class="input-item row">
          <img class="icon" src="@/assets/icons/Password@2x.png" alt />
          <input
            required
            v-model="password_again"
            class="font_16_black"
            type="password"
            placeholder="请再次输入新密码"
          />
          <!-- <span class="required">*</span> -->
        </div>
        <div class="error-tip font_12_orange">{{ errors.forgetPasswordAgain }}</div>
        <div class="tips font_12_orange">{{ tips }}</div>
        <el-button type="primary" round @click="retrieve_step2()"
          >确定</el-button
        >
      </div>
      <div class="foot">
        <p class="font_14_gray copyright">
          版权所有：深圳市泛亚人力资源股份有限公司
        </p>
        <p class="font_14_gray copyright">
          Copyright 2004-{{ new Date().getFullYear() }} fairhr All rights
          reserved.粤ICP备17155517号-1
        </p>
      </div>
    </div>
    <!-- 切换公司弹框 -->
    <el-dialog
      title="请选择您登录的公司"
      :visible.sync="companyDialogVisible"
      width="500px"
      left
      append-to-body
      modal-append-to-body
      @close="handleDialogClose"
    >
      <div class="company-list">
        <div
          class="company-item"
          v-for="item in companyoptions"
          :key="item.key"
          :class="{ active: selectedCompany === item.key }"
          @click="handleSelectCompany(item.key)"
        >
          {{ item.name }}
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="companyDialogVisible = false" style="color: black"
          >返回登录</el-button
        >
        <el-button
          type="primary"
          @click="confirmChangeCompany"
          :disabled="!selectedCompany"
        >
          确认
        </el-button>
      </span>
    </el-dialog>

    <!-- 微信未绑定账号弹框 -->
    <el-dialog
      title="绑定账号"
      :visible.sync="wechatBindDialogVisible"
      width="460px"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      @close="handleWeChatBindDialogClose"
    >
      <div class="wechat-bind-box">
        <div>账号</div>
        <el-input
          v-model="wechatBindForm.userName"
          placeholder="请输入账号"
          clearable
        ></el-input>
        <div>密码</div>
        <el-input
          v-model="wechatBindForm.password"
          placeholder="请输入密码"
          show-password
          @keyup.enter.native="confirmWeChatBind"
        ></el-input>
        <div class="wechat-bind-tip">{{ wechatBindTips }}</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="wechatBindLoading"
          @click="confirmWeChatBind"
          >登录</el-button
        >
      </span>
    </el-dialog>
  </div>

  <!-- 登录成功页面（仅在iframe中显示） -->
  <div v-show="showLoginSuccess" class="wrapper login-success-page">
    <div class="flex1200">
      <div class="success-box">
        <div class="success-icon">
          <i class="el-icon-circle-check"></i>
        </div>
        <h1 class="font_24_black">登录成功</h1>
        <p class="font_16_gray">即将为您打开企业服务平台...</p>
        <el-button
          type="primary"
          round
          @click="openHomePage"
          class="open-home-btn"
        >
          打开主页
        </el-button>
      </div>
      <div class="foot">
        <p class="font_14_gray copyright">
          版权所有：深圳市泛亚人力资源股份有限公司
        </p>
        <p class="font_14_gray copyright">
          Copyright 2004-{{ new Date().getFullYear() }} fairhr All rights
          reserved.粤ICP备17155517号-1
        </p>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { Get, Post } from '../../js/http.js'
import { getFromLocal, getToken } from '../../js/tool.js'

export default {
  components: {},
  props: {},
  data () {
    let local_user_name = getFromLocal('user_name')
      ? getFromLocal('user_name')
      : ''

    return {
      user_name: local_user_name, // 用户名
      password: '', // 密码
      password_again: '', // 再次输入密码
      code: '', // 验证码
      src: '', // 验证码图片base64
      guid: '', // GUID
      tips: '', // 输入提示
      hasGotCode: false, // 获取过验证码
      uuid: '', // 邮箱验证码uuid
      data: {}, // 登录请求所得数据
      email_code: '', // 邮箱验证码
      boardShow: 1, // 当前输入框，1：登录框；2：邮箱验证框；3：找回密码第一步；4：找回密码第二步
      user_email: '', // 安全邮箱
      tencentCaptcha: null,
      seconds: 0, // 再次发送邮箱验证码的等待时间
      companyDialogVisible: false, // 控制公司选择弹框显示
      companyoptions: [], // 公司列表数据
      selectedCompany: '', // 当前选中的公司ID
      loginLoading: false, // 登录按钮loading状态
      wechatBindSuccess: false, // 微信绑定是否成功标志，用于防止绑定成功后关闭对话框时刷新页面
      isLoginDebounce: false, // 登录防抖标志

      // 腾讯验证码相关
      captchaInstance: null, // 腾讯验证码实例
      smsTimer: null, // 倒计时定时器
      resetSmsTimer: null, // 重置密码倒计时定时器

      wechat_poll_timer: null,
      wechat_qrcode_url: '', // 微信二维码地址
      wechat_session_key: '', // 微信二维码会话key
      wechatBindDialogVisible: false, // 微信账号绑定弹框
      wechatBindLoading: false, // 微信账号绑定按钮loading
      wechatBindTips: '', // 微信账号绑定提示
      wechatBindForm: {
        userName: '',
        password: ''
      },
      showLoginSuccess: false, // 登录成功页面显示标志
      hasNavigatedToHome: false, // 是否已导航到home页面的标志
      
      // 表单验证错误提示
      errors: {
        userName: '',
        password: '',
        code: '',
        forgetUserName: '',
        emailCode: '',
        forgetPassword: '',
        forgetPasswordAgain: ''
      },
      
      // 二维码相关
      isQrcodeExpired: false, // 二维码是否过期
      qrcodeCountdown: 0, // 二维码剩余有效时间（秒）
      qrcodeExpireTimer: null // 二维码过期定时器
    }
  },
  watch: {},
  computed: {
    isLogin () {
      return this.$store.state.isLogin
    },
    waitting () {
      return this.seconds > 0
    },
    showBgImg () {
      return this.boardShow < 3 // 显示背景图片
    }
  },
  beforeDestroy () {
    if (this.smsTimer) {
      clearInterval(this.smsTimer)
    }
    if (this.resetSmsTimer) {
      clearInterval(this.resetSmsTimer)
    }
    this.stopWeChatPolling()
    this.stopQrcodeExpireTimer()
    this.wechat_session_key = ''
    this.wechat_qrcode_url = ''
  },
  methods: {
    getApiMessage (resOrErr, defaultMsg = '') {
      if (!resOrErr) return defaultMsg
      return (
        resOrErr.msg ||
        resOrErr.message ||
        (resOrErr.data && (resOrErr.data.msg || resOrErr.data.message)) ||
        defaultMsg
      )
    },
    refreshWeChatQrcode () {
      this.stopWeChatPolling()
      this.stopQrcodeExpireTimer()
      this.wechat_qrcode_url = ''
      this.wechat_session_key = ''
      this.isQrcodeExpired = false
      this.qrcodeCountdown = 180 // 3分钟 = 180秒

      Post('api/v1/wechat/qrcodes', {}).then(res => {
        const payload = res.data || {}
        this.wechat_session_key = payload.sessionKey || payload.SessionKey || ''
        this.wechat_qrcode_url =
          payload.qrCodeUrl ||
          payload.qrcodeUrl ||
          payload.qrcode ||
          payload.url ||
          ''
        this.pollWeChatQrcodeStatus()
        this.startQrcodeExpireTimer()
      })
    },
    stopQrcodeExpireTimer () {
      if (this.qrcodeExpireTimer) {
        clearInterval(this.qrcodeExpireTimer)
        this.qrcodeExpireTimer = null
      }
    },
    startQrcodeExpireTimer () {
      this.stopQrcodeExpireTimer()
      this.qrcodeCountdown = 180
      this.isQrcodeExpired = false
      
      this.qrcodeExpireTimer = setInterval(() => {
        this.qrcodeCountdown--
        if (this.qrcodeCountdown <= 0) {
          this.stopQrcodeExpireTimer()
          this.isQrcodeExpired = true
        }
      }, 1000)
    },
    handleQrcodeClick () {
      if (this.isQrcodeExpired) {
        this.refreshWeChatQrcode()
      }
    },
    stopWeChatPolling () {
      if (this.wechat_poll_timer) {
        clearTimeout(this.wechat_poll_timer)
        this.wechat_poll_timer = null
      }
    },
    scheduleWeChatPolling () {
      this.stopWeChatPolling()
      this.wechat_poll_timer = setTimeout(() => {
        this.pollWeChatQrcodeStatus()
      }, 3000)
    },
    pollWeChatQrcodeStatus () {
      if (!this.wechat_session_key) return
      Get(`api/v1/wechat/qrcodes/${this.wechat_session_key}/status`)
        .then(res => {
          const status = res.msg
          console.log('扫码状态:', status)

          // Pending: 等待扫码，继续轮询
          if (status === 'Pending') {
            this.scheduleWeChatPolling()
            return
          }

          // Unbound: 未绑定，弹出绑定对话框
          if (status === 'Unbound') {
            this.openWeChatBindDialog()
            return
          }

          // Expired: 已过期，停止轮询，等待用户手动点击刷新
          if (status === 'Expired') {
            this.stopWeChatPolling()
            this.stopQrcodeExpireTimer()
            this.isQrcodeExpired = true
            this.qrcodeCountdown = 0
            return
          }

          // Bound: 已绑定，直接登录
          if (status === 'Bound') {
            this.wechatLogin()
            return
          }

          // Success: 登录成功（可能是旧的状态值）
          if (status === 'Success') {
            this.wechatLogin()
            return
          }
        })
        .catch(() => {
          this.scheduleWeChatPolling()
        })
    },
    openWeChatBindDialog () {
      this.stopWeChatPolling()
      this.wechatBindTips = ''
      this.wechatBindForm.userName = this.user_name || ''
      this.wechatBindForm.password = ''
      this.wechatBindDialogVisible = true
    },
    handleWeChatBindDialogClose () {
      this.wechatBindLoading = false
      this.wechatBindTips = ''
      this.wechatBindForm.password = ''
      this.stopWeChatPolling()
      // 绑定成功后不刷新页面，由绑定逻辑继续处理登录
      if (!this.wechatBindSuccess) {
        this.wechat_session_key = ''
        this.wechat_qrcode_url = ''
        location.reload()
      }
      // 重置标志
      this.wechatBindSuccess = false
    },
    confirmWeChatBind () {
      if (!this.wechatBindForm.userName) {
        this.wechatBindTips = '请输入账号'
        return
      }
      if (!this.wechatBindForm.password) {
        this.wechatBindTips = '请输入密码'
        return
      }
      this.wechatBindTips = ''
      this.wechatBindLoading = true
      this.wechatbind()
    },
    //登录账号绑定微信
    wechatbind () {
      Post(`api/v1/auth/wechat/bind`, {
        password: this.wechatBindForm.password,
        userName: this.wechatBindForm.userName,
        sessionKey: this.wechat_session_key
      })
        .then(res => {
          this.wechatBindLoading = false
          if (res.isSuccess) {
            console.log('微信绑定成功，准备登录')
            // 设置标志，防止关闭对话框时刷新页面
            this.wechatBindSuccess = true
            this.wechatBindDialogVisible = false
            this.wechatBindTips = ''
            this.wechatLogin()
          } else {
            this.wechatBindTips = res.msg || '绑定失败，请重试'
          }
        })
        .catch(err => {
          this.wechatBindLoading = false
          this.wechatBindTips =
            (err && (err.msg || err.message)) || '绑定失败，请重试'
        })
    },
    //登录验证
    wechatLogin () {
      console.log('wechatLogin 调用，sessionKey:', this.wechat_session_key)
      if (!this.wechat_session_key) {
        this.$message.error('会话已过期，请刷新页面重试')
        return
      }
      
      Post(`api/v1/auth/wechat/login`, {
        sessionKey: this.wechat_session_key
      })
        .then(res => {
          console.log('微信登录接口返回:', res)
          if (res.isSuccess && res.data) {
            // 登录成功，处理登录逻辑（包括多租户选择）
            this.handleWeChatLoginSuccess(res.data)
          } else {
            // 登录失败，显示错误提示
            this.$message.error(res.msg || '登录失败，请重试')
          }
        })
        .catch(err => {
          console.error('微信登录失败:', err)
          this.$message.error((err && (err.msg || err.message)) || '登录失败，请重试')
        })
    },
    handleWeChatLoginSuccess (data) {
      this.stopWeChatPolling()
      
      // 检查数据完整性
      if (!data) {
        this.$message.error('登录数据异常，请重试')
        return
      }
      
      // 检查是否需要选择租户（支持多种字段名）
      const needSelectTenant = data.isTenantSelectionRequired || data.isTenantRequired
      
      if (needSelectTenant) {
        // 多租户账号，需要选择公司
        this.data = data
        localStorage.setItem('sessionKey', data.sessionKey)

        // 获取公司列表（支持多种字段名）
        this.companyoptions = data.availableTenants || data.tenants || []
        console.log('公司列表数据:', this.companyoptions)
        
        // 检查公司列表是否为空
        if (!this.companyoptions || this.companyoptions.length === 0) {
          this.$message.error('未找到可用的公司，请联系管理员')
          return
        }
        
        // 不默认选中任何公司
        this.selectedCompany = ''
        // 显示公司选择弹框
        this.companyDialogVisible = true
      } else {
        // 单租户账号，直接登录成功
        this.handleLoginSuccess(data)
      }
    },
    // 初始化腾讯验证码
    initTencentCaptcha () {
      if (window.TencentCaptcha) {
        this.captchaInstance = new window.TencentCaptcha(
          '192619324', // 使用和手机登录一样的AppID
          res => {
            this.handleCaptchaCallback(res)
          },
          {
            bizState: 'forgetPassword' // 业务状态，用于区分场景
          }
        )
        console.log('腾讯验证码初始化成功')
      } else {
        console.error('TencentCaptcha 未加载')
        this.tips = '验证码加载失败，请刷新页面重试'
      }
    },

    // 验证码回调处理
    handleCaptchaCallback (res) {
      if (res.ret === 0) {
        // 验证成功，调用发送邮箱验证码接口
        this.sendPasswordEmailCode(res.ticket, res.randstr)
      } else if (res.ret === 2) {
        // 用户关闭验证码
        console.log('用户关闭了验证码')
      } else {
        this.tips = '验证失败，请重试'
      }
    },

    // 显示腾讯验证码
    showTencentCaptcha () {
      // 先验证必填项
      if (!this.user_name) {
        this.tips = '请输入用户名'
        return
      }
      if (!this.user_email) {
        this.tips = '请输入邮箱'
        return
      }

      // 如果已经在倒计时中，不能再次获取
      if (this.waitting) {
        return
      }

      // 显示腾讯验证码
      if (this.captchaInstance) {
        this.captchaInstance.show()
      } else {
        this.tips = '验证码加载中，请稍后...'
        // 重新初始化
        this.initTencentCaptcha()
        setTimeout(() => {
          if (this.captchaInstance) {
            this.captchaInstance.show()
          } else {
            this.tips = '验证码加载失败，请刷新页面'
          }
        }, 1000)
      }
    },

    // 发送忘记密码的邮箱验证码（携带腾讯验证码参数）
    sendPasswordEmailCode (ticket, randstr) {
      console.log('发送邮箱验证码，ticket:', ticket, 'randstr:', randstr)

      // 发送邮箱验证码
      Post(
        'api/v1/auth/forgot-password-email',
        {},
        {
          userName: this.user_name,
          email: this.user_email,
          ticket: ticket,
          randstr: randstr
        },
        {
          headers: {
            'X-Fanyun-api-version': '1.0'
          }
        }
      )
        .then(res => {
          console.log('发送验证码响应:', res)
          if (res.isSuccess) {
            this.seconds = 60
            this.startCountDown('seconds')
            this.uuid = res.data
          } else {
            this.tips = res.msg || '发送验证码失败'
            this.seconds = 0
          }
        })
        .catch(err => {
          console.error('发送验证码错误:', err)
          this.tips = err.msg || '发送验证码失败'
          this.seconds = 0
        })
    },

    // 开始倒计时
    startCountDown (time) {
      if (this.smsTimer) {
        clearInterval(this.smsTimer)
      }

      this.smsTimer = setInterval(() => {
        if (this[time] > 0) {
          this[time]--
        } else {
          clearInterval(this.smsTimer)
          this.smsTimer = null
        }
      }, 1000)
    },

    // 对话框关闭时的处理
    handleDialogClose () {
      this.selectedCompany = ''
      // 重置登录按钮状态，使登录按钮可以再次点击
      this.loginLoading = false
      this.isLoginDebounce = false
    },
    // 选择公司
    handleSelectCompany (key) {
      console.log('选择的公司key:', key)
      this.selectedCompany = key
    },

    // 确认切换公司
    confirmChangeCompany () {
      console.log('确认切换公司，选中的key:', this.selectedCompany)
      if (!this.selectedCompany) {
        this.$message.warning('请选择要切换的公司')
        return
      }

      // 获取选中的公司信息
      const selectedCompany = this.companyoptions.find(
        company => company.key === this.selectedCompany
      )

      if (selectedCompany) {
        console.log('切换到公司:', selectedCompany)
        this.$message.success(`已切换到 ${selectedCompany.name}`)
        this.companyDialogVisible = false

        // 调用选择租户接口
        this.selectTenant(selectedCompany.key)
      } else {
        console.error('未找到选中的公司:', this.selectedCompany)
        this.$message.error('未找到选中的公司')
      }
    },
    // 验证输入
    needInput () {
      // 清空所有错误提示
      this.errors.userName = ''
      this.errors.password = ''
      this.errors.code = ''
      
      if (this.user_name === '') {
        this.errors.userName = '请输入用户名'
        return true
      } else if (this.password === '') {
        this.errors.password = '请输入密码'
        return true
      } else if (this.code === '') {
        this.errors.code = '请输入验证码'
        return true
      } else {
        return false
      }
    },
    // 登录
    login () {
      if (this.isLoginDebounce) {
        return false
      }

      if (this.needInput()) {
        return false
      }

      this.tips = '' // 清空提示语
      this.loginLoading = true // 开始loading
      this.isLoginDebounce = true // 开启防抖

      Post(
        'api/v1/auth/login',
        {},
        {
          userName: this.user_name,
          password: this.password,
          verificationCode: this.code,
          uuid: this.guid
        }
      )
        .then(res => {
          this.loginLoading = false // 结束loading
          const responseCode = res.code || (res.data && res.data.code)
          console.log('计算后的responseCode:', responseCode)
          const responseSuccess =
            typeof res.isSuccess === 'boolean'
              ? res.isSuccess
              : !!(res.data && res.data.isSuccess)
          const responseData = res.data && res.data.token ? res.data : (res.data && res.data.data) || res.data
          if (responseCode === 500) {
            const apiMsg = this.getApiMessage(res, '登录失败')
            this.tips = apiMsg
            this.$message.error(apiMsg)
            const isCodeRelatedError = /验证码|verification|captcha|uuid|code/i.test(
              apiMsg
            )
            if (isCodeRelatedError) {
              this.errors.code = apiMsg
            }
            this.get_code()
            this.isLoginDebounce = false // 解除防抖
            return false
          }

          if (responseSuccess && responseData) {
            const data = responseData
            // 检查是否需要选择租户
            if (data.isTenantSelectionRequired) {
              // 多租户账号，需要选择公司
              // 保存登录数据，用于后续获取公司选择器
              this.data = data
              localStorage.setItem('sessionKey', data.sessionKey) // 保存sessionKey

              // 从接口获取公司列表数据
              this.companyoptions = data.availableTenants || []
              console.log('公司列表数据:', this.companyoptions)
              // 不默认选中任何公司
              this.selectedCompany = ''
              // 显示公司选择弹框
              this.companyDialogVisible = true
            } else {
              // 单租户账号，直接登录成功
              this.handleLoginSuccess(data)
            }
          } else {
            this.tips = this.getApiMessage(res, '登录失败')
            this.get_code()
            this.isLoginDebounce = false // 解除防抖
          }
        })
        .catch(err => {
          console.log('登录失败进入catch，err:', err)
          console.log('登录失败进入catch，err.msg:', err ? err.msg : undefined)
          this.loginLoading = false // 结束loading

          const errorMsg =
            err.msg ||
            err.message ||
            (err.data && (err.data.msg || err.data.message)) ||
            '登录失败'
          console.log('提取的错误消息:', errorMsg)

          this.tips = errorMsg
          this.$message.error(errorMsg)

          // catch 不一定是验证码问题，仅验证码相关错误才刷新验证码
          const isCodeRelatedError = /验证码|verification|captcha|uuid|code/i.test(
            errorMsg
          )
          if (isCodeRelatedError) {
            this.errors.code = errorMsg
            this.get_code()
          }

          this.isLoginDebounce = false // 解除防抖
        })
    },

    // 选择租户
    selectTenant (tenantId) {
      // 调用选择租户接口
      Post(
        'api/v1/auth/select-tenant',
        {},
        {
          sessionKey: this.data.sessionKey,
          selectedTenantId: tenantId
        }
      )
        .then(res => {
          console.log('选择租户响应:', res)

          if (res.isSuccess && res.data) {
            // 选择租户成功，处理登录成功逻辑
            this.handleLoginSuccess(res.data)
          } else {
            this.tips = res.msg || '选择租户失败'
          }
        })
        .catch(err => {
          console.error('选择租户错误:', err)
          this.tips = err.msg || err.message || '选择租户失败'
        })
    },

    // 处理公司选择
    handleCompanyChanged (company) {
      console.log('选择的公司:', company)
      // 调用选择租户接口
      this.selectTenant(company.id)
      // 隐藏公司选择弹框
      this.showCompanyDialog = false
    },

    // 处理登录成功
    handleLoginSuccess (data) {

      
      this.data = data // 暂存数据

      // 保存登录数据
      this.saveLogin(data)

      // 获取头像
      this.getPic()
      this.getimagePic()
      // 获取未读消息
      this.getUnreadMessage()
      // 直接跳转到主页
      this.navigateToHomeWithNewWindow()
    },
    getimagePic () {
      Get('api/v1/accounts/me/avatar', {}).then(res => {
        if (res.data) {
          const avatarData = `data:${res.msg};base64,${res.data}`
          localStorage.setItem('my_pic', avatarData)
          this.$store.commit('my_pic', avatarData)
        } else {
          this.$store.commit('my_pic', require('@/assets/header.png'))
        }
      }).catch(() => {
        this.$store.commit('my_pic', require('@/assets/header.png'))
      })
    },
    getPic () {
      // 确保获取token
      const token = localStorage.getItem('token')

      Get(
        'api/v1/customers/logo',
        {
          // 不再需要 arraybuffer，因为接口现在返回 base64 字符串
          headers: {
            Authorization: 'Bearer ' + token,
            'X-Fanyun-api-version': '1.0'
          }
        },
        {}
      )
        .then(res => {
          console.log('获取头像响应:', res)

          if (res.isSuccess && res.data) {
            // 接口返回的 data 已经是 base64 字符串
            const avatarData = `data:${res.msg};base64,${res.data}`
            this.$store.commit('user_pic', avatarData)
            // 同时更新 localStorage，确保导航栏的头像立即更新
            localStorage.setItem('user_pic', avatarData)
            this.navigateToHomeWithNewWindow()
          } else {
            // 没有头像，使用默认图片
            const defaultImage = require('@/assets/header.png')
            this.$store.commit('user_pic', defaultImage)
            // 同时更新 localStorage，确保导航栏的头像立即更新
            localStorage.setItem('user_pic', defaultImage)
            this.navigateToHomeWithNewWindow()
          }
        })
        .catch(err => {
          console.error('获取头像失败:', err)
          // 出错时使用默认图片
          const defaultImage = require('@/assets/header.png')
          this.$store.commit('user_pic', defaultImage)
          // 同时更新 localStorage，确保导航栏的头像立即更新
          localStorage.setItem('user_pic', defaultImage)
          this.navigateToHomeWithNewWindow()
        })
    },
    navigateToHome () {
      if (this.$route.name === 'Home' || this.$route.path === '/') {
        return Promise.resolve()
      }
      return this.$router.replace({ name: 'Home' }).catch(err => {
        if (err && err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    navigateToHomeWithNewWindow () {
      // 防止重复调用
      if (this.hasNavigatedToHome) {
        console.log('[Login] 已经执行过跳转，跳过')
        return Promise.resolve()
      }
      this.hasNavigatedToHome = true
      
      this.notifyParentLoginSuccess()
      
      if (window.parent !== window) {
        // 在iframe中：显示登录成功页面，自动打开新窗口
        // 设置登录成功标志
        sessionStorage.setItem('loginSuccessFlag', 'true')
        this.showLoginSuccess = true
        // 延迟1.5秒后自动打开新窗口
        setTimeout(() => {
          this.openHomePage()
        }, 1500)
        return Promise.resolve()
      }
      
      // 不在iframe中：直接跳转到home页面
      return this.navigateToHome()
    },
    // 打开主页（用于手动点击按钮）
    openHomePage () {
      const token = localStorage.getItem('token')
      const homeUrl = `https://enterprise-front.test-01.54test.cn/Redirect?token=${encodeURIComponent(token)}`
      console.log('[Login] openHomePage:', homeUrl)
      const newWindow = window.open(homeUrl, '_blank')
      
      // 如果新窗口被拦截，提示用户
      if (!newWindow) {
        this.$message.warning('请允许弹出窗口，以便打开企业系统')
      }
    },
    notifyParentLoginSuccess () {
      if (window.parent !== window) {
        const token = localStorage.getItem('token')
        window.parent.postMessage({ 
          type: 'loginSuccess', 
          token: token 
        }, '*')
      }
    },
    
    // 登陆后保存数据
    saveLogin (data) {
      localStorage.setItem('token', data.token) // local存储token
      localStorage.setItem('user', this.user_name) // 默认存账户
      localStorage.setItem('server_name', data.supportStaffName)
      localStorage.setItem('server_phone', data.supportStaffPhone)
      localStorage.setItem('server_mobilephone', data.supportStaffMobilePhone)
      localStorage.setItem('server_email', data.supportStaffEmail)
      localStorage.setItem('user_name', data.userName) // 保存昵称
      localStorage.setItem('tenant_id', data.selectedTenantId) // 保存企业ID
      localStorage.setItem('tenant_name', data.selectedTenantName) // 保存企业名称
      localStorage.setItem('password', this.password) // 保存密码
      this.$store.commit('login', {
        user_name: data.userName,
        server_name: data.supportStaffName,
        server_phone: data.supportStaffPhone,
        server_mobilephone: data.supportStaffMobilePhone,
        server_email: data.supportStaffEmail,
        tenant_id: data.selectedTenantId,
        tenant_name: data.selectedTenantName
      })

      this.$store.commit('cacheToggle', true) // 开启指定页面缓存
    },
    // 完成邮箱验证
    verify () {
      this.tips = ''
      Post(
        'api/FrontUser/ConfirmUserEmail',
        {
          headers: { Authorization: 'Bearer ' + this.data.token }
        },
        {
          verificationCode: this.email_code
        }
      )
        .then(res => {
          if (res.data.code === 500) {
            this.tips = res.data.msg
            return false
          }
          let data = this.data
          this.saveLogin(data) // 保存token
          this.navigateToHomeWithNewWindow()
        })
        .catch(err => {
          this.tips = err.msg
        })
    },
    // 获取登录验证码
    get_code () {
      // 检查刷新次数是否超过限制
      this.codeRefreshCount = (this.codeRefreshCount || 0) + 1
      if (this.codeRefreshCount > 5) {
        this.tips = '获取验证码操作频繁，请稍后再试'
        this.hasGotCode = false
        return
      }
      
      this.tips = '获取中...'
      this.hasGotCode = false
      Post('api/v1/auth/verification-code')
        .then(res => {
          if (res.isSuccess == true) {
            this.guid = res.data.uuid
            this.src = `data:image/png;base64,${res.data.bytes}`
            this.hasGotCode = true
            this.tips = ''
          } else {
            throw new Error(res.msg || '获取失败')
          }
        })
        .catch(err => {
          console.error('失败:', err)
          // 如果是频繁请求错误，显示统一文案
          if (err.message && (err.message.includes('频繁') || err.message.includes('limit') || err.message.includes('Limit'))) {
            this.tips = '获取验证码操作频繁，请稍后再试'
          } else {
            this.tips = err.message || '请重试'
          }
          this.hasGotCode = false
        })
    },
    // 首次登录，请求邮箱验证码
    get_email_code () {
      Post(
        'api/SendEmail/LoginEmail',
        {
          headers: { Authorization: 'Bearer ' + this.data.token }
        },
        {}
      )
        .then(() => {
          this.seconds = 60
          this.startCountDown('seconds')
        })
        .catch(() => {})
    },
    // 倒计时（兼容原有方法）
    countDown (time) {
      this.startCountDown(time)
    },
    // 生成guid
    getGuid () {
      function S4 () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
      }
      return (
        S4() +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        S4() +
        S4()
      )
    },
    // 忘记密码
    forget () {
      this.tips = ''
      this.boardShow = 3
    },
    // 找回第一步
    retrieve_step1 () {
      this.errors.forgetUserName = ''
      
      // 校验用户名
      if (!this.user_name) {
        this.errors.forgetUserName = '请输入用户名'
        return
      } else if (this.user_name.length < 2) {
        this.errors.forgetUserName = '用户名长度不能少于2位'
        return
      } else if (this.user_name.length > 50) {
        this.errors.forgetUserName = '用户名长度不能超过50位'
        return
      }

      Get('api/v1/accounts/email', {
        userName: this.user_name
      })
        .then(res => {
          if (res.data.code === 500) {
            this.errors.forgetUserName = res.data.msg
            return false
          }
          this.user_email = res.data
          this.tips = ''
          this.password = ''
          this.boardShow = 4
        })
        .catch(err => {
          this.errors.forgetUserName = err.msg
        })
    },
    // 找回第二步
    retrieve_step2 () {
      this.errors.emailCode = ''
      this.errors.forgetPassword = ''
      this.errors.forgetPasswordAgain = ''
      
      let isValid = true
      
      // 校验邮箱验证码
      if (!this.email_code) {
        this.errors.emailCode = '请输入邮箱验证码'
        isValid = false
      } else if (this.email_code.length < 6) {
        this.errors.emailCode = '邮箱验证码长度不正确'
        isValid = false
      }
      
      // 校验密码
      if (!this.password) {
        this.errors.forgetPassword = '请输入密码'
        isValid = false
      } else if (this.password.length < 6) {
        this.errors.forgetPassword = '密码长度不能少于6位'
        isValid = false
      } else if (this.password.length > 20) {
        this.errors.forgetPassword = '密码长度不能超过20位'
        isValid = false
      } else if (!/^[a-zA-Z0-9_]+$/.test(this.password)) {
        this.errors.forgetPassword = '密码只能包含字母、数字和下划线'
        isValid = false
      }
      
      // 校验确认密码
      if (!this.password_again) {
        this.errors.forgetPasswordAgain = '请再次输入密码'
        isValid = false
      } else if (this.password !== this.password_again) {
        this.errors.forgetPasswordAgain = '两次输入的密码不一致'
        isValid = false
      }
      
      if (!isValid) {
        return false
      }

      this.tips = ''
      // 修改密码接口（使用邮箱验证码）
      Post(
        'api/v1/auth/password/reset',
        {
          userName: this.user_name,
          password: this.password,
          uuid: this.uuid,
          verificationCode: this.email_code // 使用邮箱验证码
        }
        // {
        //   headers: {
        //     'X-Fanyun-api-version': '1.0'
        //   }
        // }
      )
        .then(res => {
          if (res.isSuccess) {
            this.tips = res.msg || '密码修改成功'
            setTimeout(() => {
              location.reload(true)
            }, 3000)
          } else {
            this.tips = res.msg || '密码修改失败'
          }
        })
        .catch(err => {
          this.tips = err.msg || '密码修改失败'
        })
    },
    // 返回按钮
    toBoard (n) {
      this.user_name = ''
      this.password = ''
      this.password_again = ''
      this.code = ''
      this.tips = ''
      this.email_code = ''
      this.user_email = ''
      this.boardShow = n
    },
    enter () {
      switch (this.boardShow) {
        case 1:
          if (this.user_name && this.password && this.code) {
            this.login()
          }
          break
        case 2:
          this.verify()
          break
        case 3:
          this.retrieve_step1()
          break
        case 4:
          this.retrieve_step2()
          break
        default:
          break
      }
    },
    getUnreadMessage () {
      Get('api/v1.0/global/messages/unread')
        .then(res => {
          localStorage.setItem('unreadNum', res.data)
          this.$store.commit('unreadMessage', res.data)
        })
        .catch(() => {})
    }
  },
  created () {
    // 初始化时清理微信相关状态，确保不会继续请求之前账号的session_key
    this.stopWeChatPolling()
    this.stopQrcodeExpireTimer()
    this.wechat_session_key = ''
    this.wechat_qrcode_url = ''
    this.isQrcodeExpired = false
  },
  mounted () {
    // 加载腾讯验证码脚本
    if (!window.TencentCaptcha) {
      const script = document.createElement('script')
      script.src = 'https://ssl.captcha.qq.com/TCaptcha.js'
      script.onload = () => {
        this.initTencentCaptcha()
      }
      document.body.appendChild(script)
    } else {
      this.initTencentCaptcha()
    }
    this.refreshWeChatQrcode()
    this.guid = this.getGuid()
    if (getToken()) {
      // 如果在iframe中，检查是否是登录成功后的状态
      if (window.parent !== window) {
        // 检查是否有登录成功的标志
        const loginSuccessFlag = sessionStorage.getItem('loginSuccessFlag')
        if (loginSuccessFlag === 'true') {
          // 登录成功状态，显示登录成功页面
          this.showLoginSuccess = true
          // 延迟1.5秒后自动打开新窗口
          setTimeout(() => {
            this.openHomePage()
          }, 1500)
        }
      } else {
        // 不在iframe中，直接跳转到home页面
        this.navigateToHome()
      }
    }
    // 移除自动获取验证码，用户点击后才获取
    
    // 在iframe中添加消息转发机制：将收到的logout消息转发给父项目页面
    if (window.parent !== window) {
      window.addEventListener('message', (event) => {
        const data = event.data
        if (typeof data === 'object' && data.type === 'logout') {
          console.log('[Login] iframe收到logout消息，转发给父项目页面')
          try {
            window.parent.postMessage({ type: 'logout' }, '*')
            console.log('[Login] 已将logout消息转发给父项目页面')
          } catch (e) {
            console.log('[Login] 转发logout消息失败:', e)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-root {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f7fa;
}

/* 公司列表样式 */
.company-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
}

.company-item {
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #f9f9f9;
}

.company-item:hover {
  border-color: #4c80fa;
  color: #4c80fa;
}

.company-item.active {
  border-color: #4c80fa;
  color: #4c80fa;
}

/* 对话框底部样式 */
.dialog-footer {
  text-align: center;
  display: flex;
}

.wechat-bind-box {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wechat-bind-tip {
  min-height: 20px;
  color: #f56c6c;
  font-size: 12px;
}

.flex1200 {
  width: 1200px;
  margin: 126px auto;
}

.wrapper {
  position: relative;
  width: 100%;
  // height: 100vh;
  background: url(../../assets/icons/loginbg.png) no-repeat;
  background-size: cover;
  overflow: hidden;

  &.transitionBackground {
    background: linear-gradient(90deg, #edf4ff, #c9e0ff);
    justify-content: center;
    align-items: center;
    padding-right: 0;
  }

  .loginflex {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .login-right,
  .login-left {
    text-align: center;
    width: 420px;
  }

  .login-right > div:nth-child(1),
  .login-left > div:nth-child(1) {
    font-size: 26px;
    margin-bottom: 26px;
  }

  .login-right .saoma {
    width: 300px;
    height: 300px;
    background: #ffffff;
    border-radius: 10px;
    margin: 36px auto 10px;
    border: 1px solid #e6e6e6;
    img {
      width: 100%;
      height: 100%;
      padding: 20px;
    }
  }

  .login-right > div:nth-child(3) {
    font-size: 18px;
    color: #909399;

    span {
      color: #4c80fa;
    }
  }

  .line {
    width: 1px;
    height: 391px;
    background: #e6e6e6;
  }

  .board {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 520px;
    padding: 64px 84px 72px 76px;
    background-color: rgba(252, 252, 252, 0.4);
    box-shadow: 0px 4px 15px 1px rgba(36, 36, 36, 0.1);
    border-radius: 16px;
    border: 1px solid #ffffff;

    &.login-box {
      width: 1081px;
    }

    &.verify-email-box {
      margin-right: 320px;
    }

    &.forget-box {
      margin: 0 auto;
      align-items: flex-start;
    }

    .backBtn {
      position: absolute;
      top: 10px;
      left: 10px;
      padding: 10px;
      font-size: 30px;
      color: #949494;
    }

    .step {
      height: 95px;
      text-align: left;
      font-size: 18px;
      color: #666666;

      > div {
        margin-bottom: 5px;
      }

      input {
        width: 420px;
        height: 50px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #e6e6e6;
        padding-left: 10px;
      }

      input:-internal-autofill-previewed,
      input:-internal-autofill-selected {
        background: #ffffff !important;
      }

      .inputcode > input {
        width: 280px;
      }
    }

    .input-item {
      display: flex;
      align-items: center;
      align-self: stretch;
      height: 46px;
      margin-top: 14px;
      padding: 0 10px;
      border-bottom: 1px solid #dfdfdf;

      &:last-of-type {
        margin-top: 0;
      }

      input {
        flex: 1;
      }
    }

    .tips {
      width: 100%;
      height: 18px;
      padding-left: 0;
      text-align: left;
    }

    .forget {
      font-size: 14px;
      color: #5c74f5;
      cursor: pointer;
      text-align: left;
    }

    .inputcode {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;

      .input_code {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        min-width: 0;
      }

      .get_code {
        width: 130px;
        height: 50px;
        line-height: 50px;
        background: #e1f0ff;
        border-radius: 10px;
        color: #409eff;
        border: 1px solid #409eff;
        text-align: center;
        cursor: pointer;
        white-space: nowrap;
        margin-left: 10px;

        .font_16_darkgray {
          cursor: not-allowed;
        }
      }
    }

    .code_pic {
      width: 128px;
      height: 48px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
    }
  }

  .foot {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    text-align: center;
    padding: 20px;
  }
}

.options {
  display: flex;
  justify-content: space-between;

  .remember {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #999;

    input {
      align-self: center;
    }
  }
}

h1 {
  margin: 0;
  font-family: 'Microsoft YaHei';
  font-weight: normal;
}

.logo {
  width: 60px;
  height: 60px;
  margin-right: 9px;
}

.icon {
  width: 21px;
  height: 23px;
  margin-right: 20px;
}

input {
  height: 42px;
  border: none;
  outline: none;
}

.el-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  margin-top: 45px;
  color: #fff;
  font-size: 18px;
  box-shadow: 0px 4px 8px 0px rgba(87, 83, 245, 0.4);
  border-radius: 24px;
}

input::placeholder {
  color: #707070;
}

.code-img {
  width: 88px;
  height: 35px;
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
  .wrapper {
    justify-content: center;
    background-position: center;
    background-size: cover;
  }

  .board {
    margin-right: 0 !important;
  }
}

@media screen and (max-width: 768px) {
  .board {
    width: 90%;
    padding: 64px 40px 72px;
  }

  .tips {
    padding-left: 30px;
  }

  .code {
    flex-wrap: nowrap;
  }

  .get_code {
    min-width: 70px;
  }
}

.email-code-row {
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  // gap: 12px;
  width: 100%;
  margin-top: 20px;
}

.email-input-wrapper {
  flex: 1;
  height: 48px;
  padding: 0 16px;
  // background: #f8f9fa;
  border-radius: 8px;
  // border: 1px solid #e9ecef;
  margin-top: 0 !important;
}

.email-code-btn {
  width: 100px;
  height: 48px;
  line-height: 48px;
  // background: linear-gradient(135deg, #409eff 0%, #667eea 100%);
  // border-radius: 8px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  color: #FF7E00;
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;

  &.disabled {
    // background: #e9ecef;
    color: #999;
    cursor: not-allowed;
  }

  span {
    display: block;
  }
}

@media screen and (max-width: 480px) {
  .board {
    width: 95%;
    padding: 40px 20px 50px;
  }

  h1 {
    font-size: 16px;
  }

  .logo {
    width: 30px;
    height: 29px;
    margin-right: 6px;
  }

  .icon {
    width: 18px;
    height: 20px;
    margin-right: 15px;
  }

  .input-item {
    height: 40px;
  }

  input {
    font-size: 14px;
  }

  input::placeholder {
    font-size: 14px;
  }

  .tips {
    padding-left: 20px;
    font-size: 11px;
  }

  .get_code {
    min-width: 60px;
    font-size: 12px;
  }

  .code_pic {
    width: 60px;
    height: 24px;
  }

  .code-img {
    width: 60px;
    height: 24px;
  }

  .error-tip {
    padding-top: 4px;
    padding-left: 51px;
    font-size: 12px;
    color: #f56c6c;
    line-height: 1.5;
    text-align: left;
  }

  .required {
    color: #f56c6c;
    margin-left: 4px;
  }

  .el-button {
    height: 40px;
    margin-top: 30px;
    font-size: 16px;
  }

  .foot {
    padding: 15px;
  }

  .copyright {
    font-size: 12px;
  }
}

/* 处理高缩放比例的情况 */
@media screen and (max-height: 600px) {
  .board {
    padding: 40px 40px 50px;
  }

  .el-button {
    margin-top: 30px;
  }

  .foot {
    padding: 10px;
  }
}

/* 二维码相关样式 */
.qrcode-container {
  position: relative;
  margin: 0 auto;
  
  &.expired {
    .wechat-qrcode-image {
      filter: grayscale(100%);
      opacity: 0.5;
    }
  }
}

.qrcode-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  cursor: pointer;
}

.refresh-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #409EFF;
  border-radius: 50%;
  margin-bottom: 10px;
  animation: pulse 1.5s infinite;
  
  i {
    color: white;
    font-size: 20px;
  }
}

.expired-text {
  color: white;
  font-size: 12px;
  text-align: center;
}

.qrcode-tips {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 15px;
  
  .highlight {
    color: #409EFF;
    font-weight: bold;
  }
  
  .countdown {
    font-size: 12px;
    color: #999;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* 登录成功页面样式 */
.login-success-page {
  display: flex;
  justify-content: center;
  align-items: center;
  
  .success-box {
    text-align: center;
    background: white;
    padding: 60px 80px;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }
  
  .success-icon {
    width: 100px;
    height: 100px;
    margin: 0 auto 20px;
    background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    
    i {
      font-size: 50px;
      color: white;
    }
  }
  
  .font_24_black {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 12px;
  }
  
  .font_16_gray {
    font-size: 16px;
    color: #999;
    margin-bottom: 30px;
  }
  
  .open-home-btn {
    width: 200px;
    height: 48px;
    font-size: 16px;
    background: linear-gradient(135deg, #409eff 0%, #667eea 100%);
    border: none;
    border-radius: 24px;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
    margin: 0 auto !important;  /* 确保按钮居中 */
    display: block;  /* 确保margin: auto生效 */
  }
  
  .foot {
    position: fixed;
  }
}
</style>
